'use client';

import classnames from 'classnames';

import type { RadarProps } from './Radar.types';

import styles from './Radar.module.scss';

function Radar({ style, className, testId = 'ui-radar' }: RadarProps) {
  return (
    <div
      style={style}
      className={classnames(styles['radar'], className)}
      data-testid={testId}
    >
      <div aria-hidden="true" className={styles['wave']} />
    </div>
  );
}

export { Radar };
